import orderInitialiseModals from 'constants/api-error-modals/checkout-initialise';
import { ResponseError, openErrorModalForResponse } from 'redux/errors/open-error-modal';

export const handleOrderInitialiseError =
  (errorResponse: ResponseError) => (dispatch: WtrDispatch) => {
    dispatch(openErrorModalForResponse(orderInitialiseModals(), errorResponse));
    return true;
  };
